import { useEffect, useState } from "react";
import { getSoilSensorData } from "../api/soilSensors";

export const useGetSoilSensorParameter = ({ soilSensorId, start, end, parameter }) => {
  const [observations, setObservations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchParameter = async () => {
      setLoading(true);
      try {
        const result = await getSoilSensorData({
          soilSensorId,
          start,
          end,
          parameter
        });

        setObservations(result);
      } catch (error) {
        setError(error);
        console.error(`Error al obtener el parámetro ${parameter} del sensor:`, error);
      } finally {
        setLoading(false);
      }
    };

    fetchParameter();
  }, [soilSensorId, start, end, parameter]);

  return { observations, loading, error };
};
